











































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InputCheckBox from './InputCheckBox.vue'
import InputText from './InputText.vue'
import InputEmail from './InputEmail.vue'
import InputDateTime from './InputDateTime.vue'
import InputDate from './InputDate.vue'
import InputNumber from './InputNumber.vue'
import InputSelect from './InputSelect.vue'
import InputPhone from './InputPhone.vue'
import InputFile from './InputFile.vue'
import InputRadio from './InputRadio.vue'
import InputTextArea from './InputTextArea.vue'
import InputChoixMultiple from './InputChoixMultiple.vue'
import ZoneTextInfo from './ZoneTextInfo.vue'
import { InputInterface, TypeInput } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { PartieFormulaireInterface } from '../types/Exa_PartieFormulaire'
import { BButton } from 'bootstrap-vue'
import { isNull } from 'lodash'

@Component({
    components: {
        InputCheckBox,
        InputText,
        InputEmail,
        InputDateTime,
        InputDate,
        InputNumber,
        InputSelect, 
        InputPhone,
        InputFile,
        InputRadio,
        FontAwesomeIcon,
        InputTextArea,
        ZoneTextInfo,
        InputChoixMultiple,
        BButton
    }
})
export default class InputFormulaire extends Vue {
    @Prop() private input!: InputInterface
    @Prop() private disabled!: boolean
    @Prop() private mode_edit!: boolean
    @Prop() private partie!: PartieFormulaireInterface
    @Prop() private ignoreCondition!: boolean
    @Prop() mode_lecture!: boolean
    @Prop({ default: false }) visionneuse_enabled!: boolean
    @Prop() user!: any
    @Prop() value!: any
    @Prop({ default: false }) check_validation!: boolean
    @Prop() storeDocument!: Function | null
    @Prop() getDocument!: Function | null
    @Prop() deleteDocument!: Function | null
    @Prop() storeDocumentReference!: Function | null
    @Prop() getDocumentReference!: Function | null
    @Prop() deleteDocumentReference!: Function | null


    typeInput = TypeInput

    conditionOk = true

    condition: InputInterface | null = null

    /** 
     * evalRef 
     * Cette fonction permet d'évaluer une référence et de renvoyer la valeur correspondante. 
     *  
     * @param chaine: une chaîne de caractères représentant la référence à évaluer. 
     *  
     * @return la valeur correspondante à la référence évaluée, ou false si la référence n'est pas valide. 
     */
    evalRef(chaine:  string) {
        if (chaine && this.user && chaine.split('.')[0] === 'user' && this.user[chaine.split('.')[1]]) {
            this.input.value = this.user[chaine.split('.')[1]]
            return this.user[chaine.split('.')[1]]
        } else { 
            return false 
        }
    }

    /** 
     * inputHandler 
     * Gère la saisie de l'entrée en mettant à jour la valeur de l'input, sauf si la condition est ignorée. 
     * @param {any} e - L'événement de saisie contenant la valeur. 
     */
    inputHandler(e: any) {
        if (!this.ignoreCondition) {
            this.input.value = e.value
        }
        this.$emit('inputHandler', e)
    }

    /** 
     * showVisionneuse 
     * Cette fonction déclenche l'événement "showVisionneuse" avec le paramètre spécifié. 
     *  
     * @param e: un paramètre de type any représentant l'objet à transmettre lors de l'événement. 
     */
    showVisionneuse (e: any) {
        this.$emit('showVisionneuse', e)
    }

    /** 
     * anomalieHandler() 
     * Cette fonction met  à jour la donnée anomalie. 
     * 
     */
    anomalieHandler (e: any) {
        this.input.anomalie = e.anomalie
    }

    /** 
     * editInput 
     * Émet un événement pour éditer l'input avec les données de l'input spécifié. 
     * @param {InputInterface} input - L'objet InputInterface contenant les données de l'input à éditer. 
     */
    editInput(input: InputInterface) {
        this.$emit('editInput', input)
    }

    /** 
     * deleteInput 
     * Émet un événement pour supprimer l'input avec les données de l'input spécifié. 
     * @param {InputInterface} input - L'objet InputInterface contenant les données de l'input à supprimer. 
     */
    deleteInput(input: InputInterface) {
        this.$emit('deleteInput', input)
    }

    /** 
     * conditionHandler 
     * Gère la condition de l'input en vérifiant si la condition est satisfaite. 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('input', { immediate: true, deep: true })
    conditionHandler () {
        this.condition = null
        this.conditionOk = true
        if (this.input && this.input.condition && !this.ignoreCondition) {
            this.conditionOk = false
            this.condition = this.$store.getters['exa_formulaire/getInputById'](this.input.condition.champ_id)
            if (this.condition && (this.condition.value === this.input.condition.value || 
            (this.input.condition.value === null && this.condition.value !== '' && !isNull(this.condition.value)))) {
                this.conditionOk = true
            }
        }
    }

    /** 
     * beforeMount 
     * Appelle la fonction conditionHandler pour gérer la condition de l'input avant que le composant ne soit monté. 
     * @param {None} - Aucun paramètre requis. 
     */
    beforeMount() {
        this.conditionHandler()
    }
}
